// extracted by mini-css-extract-plugin
module.exports = {"container":"src_container__2P-0f","description":"src_description__27xys","title":"src_title__e2iYn","logo":"src_logo__cZr_z"};